import React from "react";

const EmployeeAvatar = (props) => {
    const { record } = props;

    return (
        <div className="flex items-center gap-3">
            <span className="relative flex w-10 h-10 sm:w-12 sm:h-12 shrink-0 overflow-hidden rounded-full bg-slate-100">
                <span className="flex size-full items-center justify-center font-semibold text-[12px] sm:text-[14px]">
                    {record?.employee_initials}
                </span>
            </span>
            <div>
                <div>{record?.user_detail?.full_name}</div>
                <div>{record?.emp_email}</div>
            </div>
        </div>
    );
}

export default EmployeeAvatar;
